import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Icon, Label } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import Tour from "~/models/Tour";
import "../styles/TourStatus.less";

const status = {
  shoot_requested: { label: "clientPanelConstants:shootRequested", icon: "check circle" },
  shoot_confirmed: { label: "clientPanelConstants:shootConfirmed", icon: "check circle" },
  in_process: { label: "clientPanelConstants:inProcess", icon: "clock outline" },
  photos_ready: { label: "clientPanelConstants:photosReady", icon: "check circle" },
  published: { label: "clientPanelConstants:published", icon: "check circle" },
  // not used but available
  new: { label: "clientPanelConstants:new", icon: "check circle" },
  awaiting_payment: { label: "clientPanelConstants:awaitingPayment", icon: "check circle" },
  inactive: { label: "clientPanelConstants:inactive", icon: "ban" },
  archived: { label: "clientPanelConstants:archived", icon: "archive" },
};

@observer
class TourStatus extends Component {
  render() {
    const { /** @var {Tour} */ tour, useDescription, t } = this.props;

    if (tour && tour.isArchived) {
      return (
        <Label className="archived">
          <Icon name={status.archived.icon} /> {t(status.archived.label)}
        </Label>
      );
    }

    if (!tour || !tour.isActive) {
      return (
        <Label className="inactive">
          <Icon name={status.inactive.icon} /> {t(status.inactive.label)}
        </Label>
      );
    }

    return (
      <Label className={tour.clientFacingStatus}>
        <Icon name={tour.clientFacingStatus ? status[tour.clientFacingStatus].icon : ""} />{" "}
        {useDescription
          ? t(
              `clientPanelConstants:tourStatusDescriptionSimpler${tour.clientFacingStatusDescriptionSimpler.replace(
                / /g,
                "",
              )}`,
            )
          : t(status[tour.clientFacingStatus].label)}
      </Label>
    );
  }
}
TourStatus.propTypes = {
  tour: PropTypes.instanceOf(Tour),
  useDescription: PropTypes.bool,
  t: PropTypes.func.isRequired,
};
export default withTranslation()(TourStatus);
